import React, { useEffect, useRef, useState } from 'react';
import { mediaSrc } from './Picture';

// A framed long screenshot that scrolls inside its box: hover to pan on
// pointer devices, slow auto-pan on touch. Pan distance is computed from the
// real image height so short pages barely move and long pages travel fully.
export default function ScrollShot({ mediaKey, src, alt = '', className = '', speed = 60, priority = false }) {
  const boxRef = useRef(null);
  const imgRef = useRef(null);
  const [pan, setPan] = useState(0);
  const [seconds, setSeconds] = useState(6);
  const [touch, setTouch] = useState(false);

  useEffect(() => {
    setTouch(window.matchMedia('(hover: none)').matches);
  }, []);

  const measure = () => {
    const box = boxRef.current;
    const img = imgRef.current;
    if (!box || !img || !img.naturalHeight) return;
    const scaledHeight = (img.naturalHeight / img.naturalWidth) * box.clientWidth;
    const distance = Math.max(0, scaledHeight - box.clientHeight);
    setPan(distance);
    setSeconds(Math.max(3, distance / speed));
  };

  useEffect(() => {
    const onResize = () => measure();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const source = src || mediaSrc(mediaKey, 1600);
  const style = {
    '--pan': '-' + pan + 'px',
    '--pan-seconds': seconds + 's',
  };

  return (
    <div ref={boxRef} className={'scrollshot ' + (touch ? 'scrollshot-auto ' : '') + className} style={style}>
      <img
        ref={imgRef}
        src={source}
        srcSet={src ? undefined : mediaSrc(mediaKey, 800) + ' 800w, ' + mediaSrc(mediaKey, 1600) + ' 1600w'}
        sizes="(min-width:1024px) 45vw, 90vw"
        alt={alt}
        loading={priority ? 'eager' : 'lazy'}
        decoding="async"
        onLoad={measure}
      />
    </div>
  );
}
